<template>
  <esg-base-dashboard-card title="협력사 온실가스 배출량 정보 제출"
                           style="padding:0;">
    <template #actions>
      <b-col cols="12"
             lg="12"
             md="12"
             sm="12">
        <b-form-group id="fieldset-horizontal"
                      content-cols="auto"
                      class="mb-1 mb-sm-0 text-nowrap justify-content-end">
          <b-input-group size="sm">
            <b-form-select v-model="businessLoc"
                           size="sm">
              <option disabled="true"
                      :value="'all'">주거래 사업장
              </option>
              <option :value="'all'">ALL</option>
            </b-form-select>
          </b-input-group>
        </b-form-group>
      </b-col>
    </template>
    <esg-base-chart>
      <apex-chart v-if="data"
                  height="250"
                  type="donut"
                  :options="chartOptions"
                  :series="series"/>
    </esg-base-chart>
  </esg-base-dashboard-card>
</template>
<script>
import EsgBaseDashboardCard from "@/components/esg/base/EsgBaseDashboardCard.vue";
import EsgBaseChart from "@/components/esg/base/EsgBaseChart.vue";

export default {
  name: 'CT00036',
  props: ['data'],
  components: {
    EsgBaseChart,
    EsgBaseDashboardCard
  },
  data() {
    return {
      businessLoc: 'all',
      series: [],
      chartOptions: {
        chart: {
          type: 'donut',
          events: {
            dataPointSelection: function (event, chartContext, config) {
              this.selected(config.dataPointIndex);
            }
          }
        },
        tooltip: {
          //enabled: true
          y: {
            formatter: function (val, options) {
              let percentage = Math.round(val / options.config.series.reduce((sum, current) => sum + current, 0) * 100, 0)
              return `${Number(val).toLocaleString('ko-KR')} 개 사 (${percentage}%)`;
            },
          },
        },
        legend: {
          position: 'bottom',
        },
        dataLabels: {
          enabled: false, //=> 데이터 series값 출력
        },
        responsive: [
          {
            breakpoint: 1251,
            options: {
              chart: {width: 300},
            }
          }
        ],
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                value: {
                  show: true,
                  // formatter: val => Number(val).toLocaleString('ko-KR') +`개 사`
                  formatter: function (val) {
                    return `${Number(val).toLocaleString('ko-KR')} 개 사`;
                  },
                },
                total: {
                  show: true,
                  label: 'Total',
                  color: '#000000',
                  formatter: chart => chart.config.series.reduce((sum, current) => sum + current, 0).toLocaleString('ko-KR') + '개 사'
                },
              },
            },
          },
        },
      },
    }
  },
  created() {
    this.series = [40, 209]
    this.chartOptions.labels = ['제출 완료', '제출 미완료']

  },
  watch: {
    data: {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.setSeries();
          this.setLabels();
        }
      }
    }
  },
  methods: {
    async setSeries() {
      // 시각화 데이터 추출
      this.series = this.data.map(obj => obj.values);

    },
    async setLabels() {
      // 시각화 레이블 추출
      this.chartOptions.labels = this.data.map(obj => `Scope ${obj.scope}`);
    },
  }
}
</script>
